import { Box, Skeleton, Stack } from "@mui/material"

export function ActivitySkeleton() {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        alignItems: "flex-start",
        gap: 1,
        height: 66,
      }}
    >
      <Stack>
        <Skeleton width={60} />
        <Skeleton width={80} />
      </Stack>
      <Stack alignItems="flex-end">
        <Skeleton width={120} />
        <Skeleton width={110} />
        <Skeleton width={60} />
      </Stack>
    </Box>
  )
}
